// Preselect Variant functionality
document.addEventListener('DOMContentLoaded',()=>{  
  const variant_picker_selectors = document.querySelectorAll('variant-picker');
  if(variant_picker_selectors.length > 0){
    variant_picker_selectors.forEach(variant_select=>{
      const AllInputRadio = variant_select?.querySelectorAll('input[type="radio"]');
      if(AllInputRadio.length > 0){
        AllInputRadio.forEach(radio=>{
          if(radio.classList.contains('__pre-select-option')){
            if(radio) radio.click();
          }
        })
      }
    })
  }
})